<template lang="pug">
    section
      b-container
        h1 Success
        h4 Your piece has been submitted
        p Our curators will review your submission and provide you with updates
        b-button.btn-outline(:to="{name: `Piece`, params: { pieceId: 'new' }}") Submit another
        .breadcrumbs.text-muted.small.py-3
          router-link(:to="{name: 'Art'}")
            font-awesome-icon.mr-2(icon="chevron-left")
            span Back to Art

</template>

<script>

export default {
  name: 'Home',
  components: {
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/SubmitOk.vue